import React, { useState } from 'react';

import './index.sass';


const FormikTextarea = ({ id, error, handleBlur, handleChange, maxLength, placeholder, required, showCount, touched, value, wrapperClass }) => {

  const [symbolsCount, setSymbolsCount] = useState(0);

  const handleInput = (e) => {
    const value = e.target.value;
    setSymbolsCount(value.length);
    handleChange(e);
  };

  return (
    <div className={`form-group ${(error && touched && 'form-group__error') || ''} ${wrapperClass || ''}`}>
      <label className="form-group__label" htmlFor={id}>
        <textarea
          className={`form-group__input ${value && 'active'}`}
          data-tip={error}
          id={id}
          maxLength={maxLength || 1500}
          name={id}
          onBlur={handleBlur}
          onChange={handleInput}
          resize="none"
          type="text"
          value={value}
          placeholder={placeholder || ''}
        />
      </label>
      <div className="form-group__error-tooltip">{error}</div>
      { showCount &&
        <div className="form-group__textarea-count">
          { symbolsCount } / { maxLength || 1500 }
        </div>
      }
    </div>
  )
}

export default FormikTextarea;
